import React from 'react'
import { Icon, Chip, TooltipComponent } from '../../../components'
import { useTheme } from '../../../index'
import MemoLock from '../Icons/Lock'
import MemoCheckCircle from '../Icons/CheckCircle'
import { useNotificationsHomeContext } from '../../context'
import { hexToRGBA } from '../../helpers/hextoRGBA'
import { getFormattedLabel } from '../../../utils/helpers'

export const PreferenceButton = (props) => {
  const theme = useTheme()
  const { section, topic, type, label, tooltip } = props
  let formattedLabel = getFormattedLabel(label)

  const {
    data: { globalChannelPreference },
    handlers: { setUserPreference, setUpdatedPreference }
  } = useNotificationsHomeContext()

  const chipClicked = (section, topic, type, label) => {
    if (type === 'required' || globalChannelPreference[label] === true) return
    setUserPreference((prev) => {
      const temp = { ...prev }

      const new_config = type === 'opted-out' ? 'opted-in' : 'opted-out'
      setUpdatedPreference((prev) => {
        let temp = { ...prev }
        if (!temp[topic.subscription_id]) temp[topic.subscription_id] = {}
        temp[topic.subscription_id][label] = new_config
        return temp
      })
      temp.result[section].filter(
        (subscription) => subscription.subscription_id === topic.subscription_id
      )[0].preference[label] = new_config
      return temp
    })
  }

  const OptedInIcon =
    type === 'opted-in' ? (
      <MemoCheckCircle
        sx={{
          width: '.8em',
          height: '.8em',
          color: theme.palette.primary.main
        }}
      />
    ) : null

  const optedOutStyle = {
    ...(type === 'opted-out'
      ? { backgroundColor: theme.palette.background.paper }
      : {})
  }

  return tooltip ? (
    <TooltipComponent
      title={
        type !== 'required' && globalChannelPreference[label]
          ? `${formattedLabel} is globally opted-out`
          : `${formattedLabel} is a required channel`
      }
    >
      <div key={label} style={{ ...optedOutStyle }}>
        <Chip
          key={label}
          label={
            <p
              style={{
                display: 'flex',
                gap: 0.5,
                alignItems: 'center',
                padding: 0,
                color: theme.palette.text.primary,
                margin: 0
              }}
            >
              {formattedLabel}
              <Icon
                sx={{
                  display: type === 'opted-out' ? 'none' : 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginLeft: '0.5rem'
                }}
              >
                {type === 'required' ? (
                  <MemoLock
                    sx={{
                      width: '.8em',
                      height: '.8em',
                      color: theme.palette.primary.main
                    }}
                  />
                ) : (
                  OptedInIcon
                )}
              </Icon>
            </p>
          }
          color='primary'
          variant='outlined'
          sx={{
            '& .chip-label': {
              pl: '8px',
              pr: type === 'opted-out' ? '8px' : '6px'
            },
            paddingX: 0,
            borderRadius: '5px',
            backgroundColor:
              type === 'opted-out'
                ? hexToRGBA(theme.palette.primary.main, 0.12)
                : hexToRGBA(theme.palette.primary.main, 0.32),
            color: theme.palette.primary.main,
            ...(type !== 'opted-out'
              ? { borderColor: hexToRGBA(theme.palette.primary.main, 0.32) }
              : {}),
            ...(type !== 'required' && !globalChannelPreference[label]
              ? { cursor: 'pointer' }
              : { cursor: 'not-allowed' })
          }}
          disableRipple={true}
          disabled={
            type !== 'required' && (globalChannelPreference[label] || false)
          }
          onClick={() => chipClicked(section, topic, type, label)}
        />
      </div>
    </TooltipComponent>
  ) : (
    <div style={{ ...optedOutStyle }}>
      <Chip
        key={label}
        label={
          <p
            style={{
              display: 'flex',
              gap: 0.5,
              alignItems: 'center',
              padding: 0,
              color: theme.palette.text.primary
            }}
          >
            {formattedLabel}
            <Icon
              sx={{
                display: type === 'opted-out' ? 'none' : 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: '0.5rem'
              }}
            >
              {type === 'required' ? (
                <MemoLock fontSize='small' color={'primary'} />
              ) : (
                OptedInIcon
              )}
            </Icon>
          </p>
        }
        color='primary'
        variant='outlined'
        sx={{
          '& .chip-label': {
            pl: '8px',
            pr: type === 'opted-out' ? '8px' : '6px'
          },
          paddingX: 0,
          borderRadius: '5px',
          backgroundColor:
            type === 'opted-out'
              ? hexToRGBA(theme.palette.primary.main, 0.12)
              : hexToRGBA(theme.palette.primary.main, 0.32),
          color: theme.palette.primary.main,
          ...(type !== 'opted-out'
            ? { borderColor: hexToRGBA(theme.palette.primary.main, 0.32) }
            : { borderColor: theme.palette.text.chip }),
          ...(type !== 'required' || !globalChannelPreference[label]
            ? { cursor: 'pointer' }
            : { cursor: 'not-allowed' })
        }}
        disableRipple={true}
        onClick={() => chipClicked(section, topic, type, label)}
      />
    </div>
  )
}

export default PreferenceButton
